import { StrictMode } from "react";
import ReactDOM from "react-dom";
import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import {
  Link,
  DirectLink,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller
} from "react-scroll";

// STYLES
import "./components/mainComponents/home.css";
import "./components/mainComponents/homepage.css";
import "./styles.css";

// COMPONENTS
import Header from "./components/header/header";
import Banner from "./components/banner/banner";
import Platinum from "./components/platinum/platinum";
import Footer from "./components/footer/footer";
import FirstComp from "./components/mainComponents/firstComp";
import SecondComp from "./components/mainComponents/secondComp";
import ThirdComp from "./components/mainComponents/thirdComp";
import FourthComp from "./components/mainComponents/fourthComp";
import FifthComp from "./components/mainComponents/fifthComp";
import Navigation from "./components/navigation/navigation";
import HomeText from "./components/homeText/homeText";
import Homepage, { Homepart } from "./components/mainComponents/homepage";
import ContentPage from "./components/mainComponents/contentPage";

export default function App() {
  window.scrollTo({
    top: 0
    //  behavior: "smooth"
  });
  useEffect(() => {
    scroll.scrollToTop();
  });

  return (
    <>
      <div className="main-body">
        {/* <Header /> */}
        <ContentPage />
        {/* <Homepage /> */}
      </div>
    </>
  );
}
